import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import Loading from "../../Components/Loading";
import Select from "react-select";
import BackendClient from "../../BackendClient";

const mapStateToProps = ({ identity }) => ({
  identity
});

class Statistics extends Component {
  state = {
    view: 0,
    loading: true
  };

  componentDidMount = () => {
    const date = moment(new Date()).format("YYYY-MM-D");
    const user = this.props.identity;
    const theatreId = user.theatreId;

    const view = user.position !== "admin" && theatreId ? 2 : 1;
    const cinemaParams = {};
    theatreId && Object.assign(cinemaParams, { theatreId });

    Promise.all([
      BackendClient.getStatistic({ date, ...cinemaParams }).fetchJson(),
      BackendClient.getStatisticDates(cinemaParams).fetchJson()
    ]).then(([statistic, dates]) => {
      this.setState({ loading: false, dates, statistic, view });
    });
  };

  onChangeDateStatistics = event => {
    const date = event.value
      ? event.value
      : moment(new Date()).format("YYYY-MM-D");
    const params = { date };
    const { theatreId } = this.props.identity;
    theatreId && Object.assign(params, { theatreId });
    this.setState({ loading: true });
    BackendClient.getStatistic({ date, ...params })
      .fetchJson()
      .then(statistic => this.setState({ loading: false, statistic }));
  };

  onInputChangeDateStatistics = event => {};

  getArrowIcon(currentValue, previousValue) {
    if ((currentValue || previousValue) && currentValue > previousValue) {
      return <img src="/images/icon-arrow-up.png" alt="" />;
    }
    if ((currentValue || previousValue) && currentValue < previousValue) {
      return <img src="/images/icon-arrow-down-red.png" alt="" />;
    }
    return "";
  }

  render() {
    let date = new Date();
    var options = {
      month: "long",
      year: "numeric"
    };

    date = date.toLocaleString("ru", options);

    const { dates, statistic, loading } = this.state;
    let content;
    if (loading) {
      content = <Loading loading={this.state.loading} />;
    } else {
      content = (
        <ul className="office-statistics__list">
          {(this.state.view === 1 && <div />) || (
            <div style={{ display: "contents" }}>
              <li className="office-statistics__item">
                <div className="office-statistics__item-header">
                  <span className="value">
                    {statistic.current ? statistic.current.theatreTickets : 0}
                  </span>
                  {this.getArrowIcon(
                    statistic.current.theatreTickets,
                    statistic.previous.theatreTickets
                  )}
                </div>
                <div className="office-statistics__item-body">
                  проданных билетов вашим кинотеатром
                </div>
              </li>
              <li className="office-statistics__item">
                <div className="office-statistics__item-header">
                  <span className="value">
                    {statistic.current.theatreTicketCost
                      ? statistic.current.theatreTicketCost
                      : 0}
                  </span>
                  <span className="gray">₽</span>
                  {this.getArrowIcon(
                    statistic.current.theatreTicketCost,
                    statistic.previous.theatreTicketCost
                  )}
                </div>
                <div className="office-statistics__item-body">
                  средняя цена билета вашего кинотеатра
                </div>
              </li>
              <li className="office-statistics__item">
                <div className="office-statistics__item-header">
                  <span className="value">
                    {statistic.current.theatreMoney}
                  </span>
                  <span className="gray">₽</span>
                  {this.getArrowIcon(
                    statistic.current.theatreMoney,
                    statistic.previous.theatreMoney
                  )}
                </div>
                <div className="office-statistics__item-body">ваша выручка</div>
              </li>
            </div>
          )}
          <li className="office-statistics__item">
            <div className="office-statistics__item-header">
              <span className="value">{statistic.current.theatresCount}</span>
              {this.getArrowIcon(
                statistic.current.theatresCount,
                statistic.previous.theatresCount
              )}
            </div>
            <div className="office-statistics__item-body">кинотеатров</div>
          </li>
          <li className="office-statistics__item">
            <div className="office-statistics__item-header">
              <span className="value">{statistic.current.ticketsTotal}</span>
              {this.getArrowIcon(
                statistic.current.ticketsTotal,
                statistic.previous.ticketsTotal
              )}
            </div>
            <div className="office-statistics__item-body">
              проданных билетов всей сети
            </div>
          </li>
        </ul>
      );
    }

    return (
      <div className="office-statistics">
        <div className="office-statistics__header">
          <div className="office-statistics__header_text">Общая статистика</div>
          <div className="chooseMonth">
            {
              <Select
                onChange={this.onChangeDateStatistics}
                onInputChange={this.onInputChangeDateStatistics}
                isMulti={false}
                options={dates || []}
                className="statisticsSelect selectReact"
                classNamePrefix="statisticsSelectItems selectReact"
                сlearable
                placeholder={date}
                styles={{
                  control: styles => ({
                    ...styles,
                    cursor: "pointer",
                  }),
                  option: styles => ({
                    ...styles,
                    cursor: "pointer",
                  }),
                }}
              />
            }
          </div>
        </div>
        {content}

        <div className="office-statistics__date-picker list-picker" />
      </div>
    );
  }
}

export default connect(mapStateToProps)(Statistics);



// WEBPACK FOOTER //
// ./src/containers/office/Statistics.jsx